export const msConfig = {
    serviceInstance: new Object()
}


// WEBPACK FOOTER //
// ./src/app/typescripts/free/modals/modalService.config.ts